<template>
    <base-frame :isMe="isMe" :userType="msgObj.userType"  chatmessageCls="msg-img" :sendType="msgObj.msgStatus" >
        <a slot="chatmessage" :href="msgObj.content.url" :download="msgObj.content.name"  v-if="msgObj.content.loaded">
          <img :src="msgObj.content.icon">
        </a>
        <img slot="chatmessage" :src="'./static/img/loading.gif'" width="20" v-else>
    </base-frame>
</template>

<script>
import BaseFrame from './BaseFrame'
export default {
  name: 'tpl-file',
  components: {
    BaseFrame
  },
  props: {
    msgObj: Object,
    isMe: Boolean
  },
}
</script>




// WEBPACK FOOTER //
// src/components/templates/TplFile.vue